import { render, staticRenderFns } from "./ContactDetailsSkeleton.vue?vue&type=template&id=8a9d8c7c&scoped=true&"
import script from "./ContactDetailsSkeleton.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsSkeleton.vue?vue&type=style&index=0&id=8a9d8c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9d8c7c",
  null
  
)

export default component.exports